import React                     from 'react';
import classNames                from 'classnames';
import { Observe }               from 'rewire-core';
import {
  WithStyle,
  FormView
}                                from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import Typography                from '@material-ui/core/Typography';
import DraggableResizableDialog  from '../ui/DraggableResizableDialog';
import advancedSearchDialogModel from './AdvancedSearchDialogModel';
import { withStyles }            from '../utility/styles';


const styles = (_theme: Theme) => ({
  selectMenuPaper: {
    minWidth: '175px !important',
  },
  addFilterButton: {
    textTransform: 'none',
  },
  addIcon: {
    marginRight: '5px',
  },
  placeholder: {
    '& input': {
      fontStyle: 'italic',
    },
    '& span > span': {
      fontStyle: 'italic',
    },
  },
  heading: {
    marginLeft: '10px',
    color: 'gray',
  },
});

interface IAdvancedSearchDialogProps {
}

type AdvancedSearchDialogProps = WithStyle<ReturnType<typeof styles>, IAdvancedSearchDialogProps>;

class AdvancedSearchDialog extends React.PureComponent<AdvancedSearchDialogProps> {
  constructor(props: AdvancedSearchDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    advancedSearchDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    const { classes } = this.props;

    return <Observe render={() => (
      <FormView form={advancedSearchDialogModel.form} onSubmit={advancedSearchDialogModel.actionFn('search')}>
        <Typography variant='h6' className={classes.heading}>Job Properties</Typography>
        <div className='content'><advancedSearchDialogModel.form.field.areas.Editor             className={classNames(classes.placeholder, 'span4')} /></div>
        <div className='content'><advancedSearchDialogModel.form.field.groups.Editor            className={classNames(classes.placeholder, 'span4')} /></div>
        <div className='content'><advancedSearchDialogModel.form.field.occupations.Editor       className={classNames(classes.placeholder, 'span4')} /></div>
        <div className='content'><advancedSearchDialogModel.form.field.assignedEmployees.Editor className={classNames(classes.placeholder, 'span4')} /></div>
        <div className='content'><advancedSearchDialogModel.form.field.generators.Editor        className={classNames(classes.placeholder, 'span4')} /></div>

        <Typography variant='h6' className={classes.heading}>Other Properties</Typography>
        <div className='content'><advancedSearchDialogModel.form.field.employees.Editor         className={classNames(classes.placeholder, 'span4')} /></div>
        <div className='content'><advancedSearchDialogModel.form.field.templates.Editor         className={classNames(classes.placeholder, 'span4')} /></div>
        <div className='content'><advancedSearchDialogModel.form.field.reasons.Editor           className={classNames(classes.placeholder, 'span4')} /></div>
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='sm' DialogProps={{dialog: advancedSearchDialogModel}} DraggableResizableBoxProps={{minWidth: '345px', minHeight: '480px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IAdvancedSearchDialogProps>(styles, AdvancedSearchDialog);
